import { BiContextAllowedProps } from '@wix/da-bi/pkg/events';
import { reduxKey } from './constants';

export interface ModalOptions {
  params?: any;
  wrapInModal?: boolean;
  biContext?: BiContextAllowedProps;
  closeBtnClassName?: string;
}

export interface ModalStackItem {
  id: number;
  type: string;
  options: ModalOptions;
}

export interface ModalStackState {
  [reduxKey]: ModalStackItem[];
}

// ModalTypes shared between projects
export enum ModalType {
  STATUS_UPDATE = 'STATUS_UPDATE',
  JOURNAL = 'JOURNAL',
  LITERATURE = 'LITERATURE',
  COMMISSION = 'COMMISSION',
  CONFIRMATION = 'CONFIRMATION',
  GLOBAL_CONFIRMATION = 'GLOBAL_CONFIRMATION',
  GLOBAL_CONFIRMATION_FOR_MM = 'GLOBAL_CONFIRMATION_FOR_MM',
  POLL_EDIT = 'POLL_EDIT',
  GIVE_BADGE = 'GIVE_BADGE',
  LEGACY_GIVE_LLAMA_BADGE = 'LEGACY_GIVE_LLAMA_BADGE',
  GIVE_ITEM_FAILURE = 'GIVE_ITEM_FAILURE',
  GIVE_POINTS = 'GIVE_POINTS',
  GIVE_POINTS_SUCCESS = 'GIVE_POINTS_SUCCESS',
  COMMENT_THREAD = 'COMMENT_THREAD',
  VERIFICATION = 'VERIFICATION',
  VERIFICATION_SUCCESSFUL = 'VERIFICATION_SUCCESSFUL',
  DEVIATION_BACKGROUND_PICKER = 'DEVIATION_BACKGROUND_PICKER',
  USER_BLOCK = 'USER_BLOCK',
  REPORT_DEVIATION_MODAL = 'REPORT_DEVIATION_MODAL',
  DEVIATION_GROUP_LIST = 'DEVIATION_GROUP_LIST',
  MOBILE_DEVIATION_PCP = 'MOBILE_DEVIATION_PCP',
  USER_SYMBOLS_LEGEND = 'USER_SYMBOLS_LEGEND',
  MOBILE_CHAT_LIST = 'MOBILE_CHAT_LIST',
  MOBILE_CHAT_WINDOW = 'MOBILE_CHAT_WINDOW',
  MOBILE_CHAT_WINDOW_NEW = 'MOBILE_CHAT_WINDOW_NEW',
  AWARD_BADGE = 'AWARD_BADGE',
  RECEIVED_AWARDS = 'RECEIVED_AWARDS',
  TIER_EDIT = 'TIER_EDIT',
  TIER_UNSUBSCRIBE = 'TIER_UNSUBSCRIBE',
  TIER_UNSUBSCRIBE_BY_USERNAME = 'TIER_UNSUBSCRIBE_BY_USERNAME',
  TIER_CHANGE = 'TIER_CHANGE',
  GROUP_CLOSED_WATCH = 'GROUP_CLOSED_WATCH',
  GROUP_JOIN_PENDING = 'GROUP_JOIN_PENDING',
  GROUP_MESSAGE_ADMINS = 'GROUP_MESSAGE_ADMINS',
  FAVOURITED_BY = 'FAVOURITED_BY',
  DEVIANTS_LIST = 'DEVIANTS_LIST',
  COLLECTION_POPOVER = 'COLLECTION_POPOVER',
  LOADING_SCREEN = 'LOADING_SCREEN',
  CREATE_PREMIUM_FOLDER = 'CREATE_PREMIUM_FOLDER',
  DEVIATION_SUBMIT = 'DEVIATION_SUBMIT',
  DISCORD_CONNECT_SUCCESS = 'DISCORD_CONNECT_SUCCESS',
  DISCORD_DISCONNECT = 'DISCORD_DISCONNECT',
  BADGE_INFO = 'BADGE_INFO',
  ADD_TO_GROUP = 'ADD_TO_GROUP',
  ADOPT_SELLER_MODAL = 'ADOPT_SELLER_MODAL',
  ADOPT_SELLER_GIFT_MODAL = 'ADOPT_SELLER_GIFT_MODAL',
  ADOPT_BUYER_MODAL = 'ADOPT_BUYER_MODAL',
  EXCLUSIVE_TRANSACTION_HISTORY_MODAL = 'EXCLUSIVE_TRANSACTION_HISTORY_MODAL',
  CONTENT_FILTER_SETTINGS = 'CONTENT_FILTER_SETTINGS',
  AI_SUPPRESSION_SETTINGS = 'AI_SUPPRESSION_SETTINGS',
  BIRTHDAYS = 'BIRTHDAYS',
  MOBILE_NOTES_DRAWER = 'MOBILE_NOTES_DRAWER',
  DEVIATION_SUBMIT_SCHEDULE = 'DEVIATION_SUBMIT_SCHEDULE',
  DEVIATION_SUBMIT_SCHEDULE_LIMIT_REACHED = 'DEVIATION_SUBMIT_SCHEDULE_LIMIT_REACHED',
  DEVIATION_SUBMIT_ADDITIONAL_IMAGES = 'DEVIATION_SUBMIT_ADDITIONAL_IMAGES',
  DEVIATION_SUBMIT_ADDITIONAL_IMAGES_UPSELL = 'DEVIATION_SUBMIT_ADDITIONAL_IMAGES_UPSELL',
  DEVIATION_SUBMIT_MAIN_IMAGE_POPUP = 'DEVIATION_SUBMIT_MAIN_IMAGE_POPUP',
  STUDIO_PRESETS = 'STUDIO_PRESETS',
  STUDIO_BATCH_EDIT = 'STUDIO_BATCH_EDIT',
  STUDIO_TIER_CREATE = 'STUDIO_TIER_CREATE',
  STUDIO_FOLDER = 'STUDIO_FOLDER',
  PROGRESS = 'PROGRESS',
  SAFE_URL = 'SAFE_URL',
  PUSH_NOTIFICATIONS = 'PUSH_NOTIFICATIONS',
  PRIVATE_SELL_CONFIRMATION = 'PRIVATE_SELL_CONFIRMATION',
  GIFT_EXCLUSIVE_UPSELL = 'GIFT_EXCLUSIVE_UPSELL',
  STUDIO_BATCH_SCHEDULE = 'STUDIO_BATCH_SCHEDULE',
  MINI_MURO = 'MINI_MURO',
  MACRO_MURO = 'MACRO_MURO',
  MOBILE_MURO = 'MOBILE_MURO',
  MINI_MOBILE_MURO = 'MINI_MOBILE_MURO',
  BOOST_DEVIATION = 'BOOST_DEVIATION',
  ORIGINAL_DEVIATION = 'ORIGINAL_DEVIATION',
  GALLERY_DISPLAY_SETTINGS = 'GALLERY_DISPLAY_SETTINGS',
  POST_PROCUREMENT = 'POST_PROCUREMENT',
}
